<template>
  <base-stack direction="row" align="center">
    <label class="toggle-switch">
      <input type="checkbox" :checked="value" @change="handleChange" :disabled="disabled" />
      <span class="slider"></span>
    </label>
    <slot />
  </base-stack>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BaseToggle extends Vue {
  @Prop({ type: Boolean, required: true }) value!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  handleChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.$emit('input', target.checked);
  }
}
</script>

<style lang="scss" scoped>
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .slider {
      background-color: $color-theme-red;
    }

    &:checked + .slider:before {
      transform: translateX(26px);
    }

    &:disabled + .slider {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: $color-disabled;
    transition: 0.4s;
    border-radius: 34px;

    &:before {
      position: absolute;
      content: '';
      height: 26px;
      width: 26px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      transition: 0.4s;
      border-radius: 50%;
    }
  }
}
</style>
